import { inject, Injectable } from '@angular/core';
import { EntityListStore } from '@webapp/core/stores/entity-list-store.service';
import { PaginationParams } from '@webapp/core/ui/components/pagination/pagination.interfaces';
import { UsersStoreService } from '@webapp/users/store/users-store.service';
import { firstValueFrom, map } from 'rxjs';
import { buildStatus } from '../common/map';
import { IPolicyRow } from '../interfaces/policies.interface';
import { PoliciesService } from '../services/policies.service';

@Injectable({
	providedIn: 'root',
})
export class UserPoliciesStoreService {
	listStore: EntityListStore<IPolicyRow>;
	service = inject(PoliciesService);
	private userStore = inject(UsersStoreService);

	constructor() {
		this.listStore = new EntityListStore<IPolicyRow>(
			(params: PaginationParams) =>
				firstValueFrom(
					this.service
						.get({
							...params,
							filters: {
								...params.filters,
								client: {
									userId: this.userStore.get()()?.id,
								},
							},
						})
						.pipe(
							map(res => ({
								...res,
								data: res.data.map(policy => ({
									...policy,
									...buildStatus(policy.status),
								})),
							}))
						)
				)
		);
	}

	public getRows() {
		return this.listStore.select('rows');
	}
}